import microuniversoApi from "app/api/microuniversoApi";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { CepPorEndereco, ComissoesEndereco } from "app/types/comissoes/DadosBasicosIndicadores";
import { ICidade } from "app/types/ICidade";
import { IEndereco } from "app/types/IEndereco";
import { Bairro } from "app/types/NovoEndereco";
import { tratamentoErroPadrao } from "app/use-cases";
import globalMU from "globalMU";
import React, { useEffect, useState } from "react";
import { ModalSelecionarCep } from "./modal-selecionar-cep/ModalSelecionarCep";
import { NovoEndereco } from "./NovoEnderecoComissoes";

export type NovoEnderecoComissoesContainerProps = {
    endereco: IEndereco;
    clienteNaoCadastrado: boolean
    cpfCnpj: string;
    numeroEBairroObrigatorio: boolean
    utilizarBairrosPreCadastrados: boolean;
    ativaEditarEndereco?: (ativa: boolean, endereco: IEndereco) => void;
    adicionarEndereco: (endereco: IEndereco) => void;
    editarEndereco: (endereco: IEndereco) => void;
}


export const NovoEnderecoComissoesContainer = (props: NovoEnderecoComissoesContainerProps) => {

    const [dadosEditarEndereco, setDadosEditarEndereco] = useState<ComissoesEndereco>({ Classificacoes: null, Estados: null });
    const [cidadesPorEstado, setCidadesPorEstado] = useState<ICidade[]>();
    const [bairros, setBairros] = useState<Bairro[]>([]);
    const [endereco, setEndereco] = useState<IEndereco>(props.endereco ?? {});
    const [exibeModal, setExibeModal] = useState(false);
    const [dadosModalEndereco, setDadosModalEndereco] = useState<PagedMessageResponse<CepPorEndereco>>()

    const onDadosEdicaoEndereco = async () => {
        try {
            globalMU.blockUI();
            const resposta = await microuniversoApi.Cliente.dadosEditarEndereco(props.cpfCnpj, props.clienteNaoCadastrado);
            if (!("HasErrors" in resposta)) {
                setDadosEditarEndereco(resposta)
            }
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const onListarCidadesPorEstado = async (codigoEstado: number) => {
        try {
            globalMU.blockUI();
            const resposta = await microuniversoApi.Comum.listarCidadesPorEstado(codigoEstado);
            (!("HasErrors" in resposta)) && setCidadesPorEstado(resposta)
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const onListarBairros = async (bairro: string) => {
        if (!props.utilizarBairrosPreCadastrados) return; // 453510
        try {
            globalMU.blockUI();
            const bairros = await microuniversoApi.Comum.listarBairrosPreCadastrados(bairro);
            (!("HasErrors" in bairros)) ? setBairros(bairros) : setBairros([])
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    };

    const pesquisaPorCep = async (cep: string) => {
        cep = cep.replace(/\D/g, "") // Remove caracteres não numéricos
        if (cep.length <= 0) {
            return
        }
        try {
            globalMU.blockUI();
            const resposta = await microuniversoApi.Comum.obterEnderecoPorCep(cep?.trim());
            if (!("HasErrors" in resposta)) {
                setEndereco({
                    ...endereco,
                    Logradouro: resposta.Logradouro,
                    Bairro: resposta.Bairro,
                    Cep: resposta.Cep,
                    Cidade: resposta.Cidade,
                    Estado: resposta.Estado,
                    NomeCidade: resposta.NomeCidade,
                    CodigoCidade: resposta.CodigoCidade,
                    SiglaUf: resposta.SiglaUf,
                    CodigoEstado: resposta.CodigoEstado
                })
                onListarCidadesPorEstado(resposta.Estado.Codigo);
                onListarBairros(resposta.Bairro);
            }
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const pesquisaPorEndereco = async (numeroPagina?: number) => {
        try {
            globalMU.blockUI();
            const resposta = await microuniversoApi.Comum.obterCepPorEndereco({
                Bairro: endereco.Bairro,
                Logradouro: endereco.Logradouro,
                NomeCidade: endereco.Cidade != null ? endereco.Cidade.Nome : "",
                NumeroPagina: numeroPagina ?? 1,
                SiglaUf: endereco.Estado?.Sigla ?? "",
                TamanhoPagina: 20,
            });
            if (!("HasErrors" in resposta)) {
                setDadosModalEndereco(resposta)
                resposta?.Entities?.length > 1 && setExibeModal(true);
            }
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const onAdicionarOuAtualizarEndereco = (endereco: IEndereco) => {
        props.endereco == null ? props.adicionarEndereco({ ...endereco, PermitirEditar: true }) : props.editarEndereco(endereco)

        onVoltarParaCadastroIndicador();
    }

    const atualzaDadosASerSalvos = (endereco: IEndereco) => {
        setEndereco(endereco)
    }

    const onVoltarParaComissoes = () => {
        props.ativaEditarEndereco(false, null);
    }

    const onVoltarParaCadastroIndicador = () => {
        props.ativaEditarEndereco(false, null);
    }

    useEffect(() => {
        onDadosEdicaoEndereco();
        props.endereco && onListarCidadesPorEstado(props.endereco?.CodigoEstado);
        props.endereco?.Bairro && onListarBairros(props.endereco?.Bairro);
    }, [])


    return (
        <>
            <Breadcrumb2Container
                passos={["Comissões", "Cadastro Indicador", "Novo Endereço"]}
                id='NovoEnderecoComissoesContainer'
                onPassoSelecionado={passo => {
                    if (passo == "Comissões") {
                        onVoltarParaComissoes()
                    }
                    if (passo == "Cadastro Indicador") {
                        onVoltarParaCadastroIndicador()
                    }
                }}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onBotaoVoltarClicado={onVoltarParaComissoes}
            />

            <NovoEndereco
                utilizarBairrosPreCadastrados={props.utilizarBairrosPreCadastrados}
                numeroEBairroObrigatorio={props.numeroEBairroObrigatorio}
                pesquisaPorEndereco={pesquisaPorEndereco}
                onErrorValidacao={(mensagemErroNovoEndereco) => globalMU.showErrorMessage(mensagemErroNovoEndereco)}
                bairros={bairros}
                estados={dadosEditarEndereco.Estados}
                cidades={cidadesPorEstado}
                opcoesTipo={dadosEditarEndereco.Classificacoes}
                endereco={endereco}
                onAdicionar={onAdicionarOuAtualizarEndereco}
                onPesquisarCep={pesquisaPorCep}
                onListarCidadesPorEstado={onListarCidadesPorEstado}
                atualzaDadosASerSalvos={atualzaDadosASerSalvos}
                onListarBairros={onListarBairros}
                dadosModalEndereco={dadosModalEndereco}
            />

            {dadosModalEndereco &&
                <ModalSelecionarCep
                    dados={dadosModalEndereco}
                    open={exibeModal}
                    onFecharModal={() => setExibeModal(false)}
                    onEnderecoSelecionado={(endereco) => setEndereco({ ...endereco, Logradouro: endereco.Logradouro, Bairro: endereco.Bairro, Cep: endereco.Cep })}
                    onAlterarListaSelecionadaEndereco={pesquisaPorEndereco}
                />
            }

        </>
    )
}
